module.exports = __webpack_public_path__ + "static/media/Rider_Blue.6a2777fd.svg";